/* <tsa-article-toc data-content="tsa-article-body">
   Builds a table of contents from the .ta-h2 headings inside the referenced
   container. Article bodies ship without heading ids, so ids are generated
   here and kept stable by slugging the heading text.
   Renders nothing below 3 headings or when the container is missing. */

/* Wrapped in an IIFE: this is a classic script, so top-level declarations
   would land in global scope. `slugify` in particular is a common name in
   third-party and app scripts, and a duplicate top-level `const` throws,
   which would take the TOC down with it. */
(function () {
const MIN_HEADINGS = 3;

function slugify(text, used) {
  const base =
    text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';
  let slug = base;
  let n = 2;
  while (used.has(slug)) {
    slug = base + '-' + n;
    n += 1;
  }
  used.add(slug);
  return slug;
}

class TsaArticleToc extends HTMLElement {
  connectedCallback() {
    const content = document.getElementById(this.dataset.content);
    if (!content) return;

    this.headings = Array.from(content.querySelectorAll('.ta-h2'));
    if (this.headings.length < MIN_HEADINGS) return;

    const used = new Set();
    const list = document.createElement('ol');

    this.headings.forEach((heading) => {
      if (!heading.id) heading.id = slugify(heading.textContent || '', used);
      else used.add(heading.id);

      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + heading.id;
      a.textContent = heading.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });

    const title = document.createElement('p');
    title.className = 'tsa-article__toc-title';
    title.textContent = 'On this page';

    const nav = document.createElement('nav');
    nav.setAttribute('aria-label', 'On this page');
    nav.appendChild(title);
    nav.appendChild(list);
    this.appendChild(nav);

    this.links = Array.from(list.querySelectorAll('a'));
    this.onScroll = this.onScroll.bind(this);
    this.ticking = false;
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.sync();
  }

  disconnectedCallback() {
    if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(() => {
      this.sync();
      this.ticking = false;
    });
  }

  /* Active heading is the last one whose top has passed the header line. */
  sync() {
    const headerHeight =
      parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
        10
      ) || 75;
    const line = headerHeight + 24;

    let activeIndex = 0;
    this.headings.forEach((heading, i) => {
      if (heading.getBoundingClientRect().top <= line) activeIndex = i;
    });

    this.links.forEach((link, i) => {
      if (i === activeIndex) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  }
}

customElements.define('tsa-article-toc', TsaArticleToc);
})();
